export const UNCATEGORIZED = 'Uncategorized';

export const DND_TYPES = {
  category: 'MEDIA_CATEGORY',
  image: 'MEDIA_IMAGE',
  images: 'MEDIA_IMAGES',
};
